import React, {useEffect, useState} from 'react';
import {Button, Dialog} from '@betareader/design-system';
import imageUtil from '../utils/imageUtil';

const startingIndex = (images, index) =>
  Number.isInteger(index) && index >= 0 && index < images.length ? index : 0;

const ImageSlideShow = ({images = [], startIndex = 0, onClose}) => {
  const [currentIndex, setCurrentIndex] = useState(() => startingIndex(images, startIndex));

  useEffect(() => {
    setCurrentIndex(startingIndex(images, startIndex));
  }, [images, startIndex]);

  useEffect(() => {
    if (!images.length) return undefined;
    const onKeyDown = event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const direction = event.key === 'ArrowLeft' ? -1 : 1;
      setCurrentIndex(index => (index + direction + images.length) % images.length);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [images.length]);

  if (!images.length) return null;

  const move = direction => {
    setCurrentIndex(index => (index + direction + images.length) % images.length);
  };
  const image = images[currentIndex] || images[0];

  return (
    <Dialog
      open
      title={`Image ${currentIndex + 1} of ${images.length}`}
      onClose={onClose}
      className="br-image-slideshow"
      actions={<>
        <Button variant="secondary" onClick={() => move(-1)} aria-label="Previous image">Previous</Button>
        <Button variant="secondary" onClick={() => move(1)} aria-label="Next image">Next</Button>
        <Button variant="ghost" onClick={onClose}>Close</Button>
      </>}
    >
      <img
        className="br-image-slideshow__image"
        src={imageUtil.getImageUrl({
          operation: 'width',
          size: 600,
          originalImageUrl: image.url,
        })}
        alt={image.alt || `Image ${currentIndex + 1} of ${images.length}`}
      />
    </Dialog>
  );
};

export default ImageSlideShow;
